var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.hasPOSAccess
      ? _c("section", { staticClass: "content-container" }, [
          _c(
            "div",
            { staticClass: "access-denied-container" },
            [
              _c("h4", [_vm._v("POS Access Required")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n        Inventory management is part of our POS system add-on. Please upgrade\n        your subscription to access this feature.\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "btn btn-primary",
                  attrs: { to: "/settings/billing" },
                },
                [_vm._v("\n        Upgrade Subscription\n      ")]
              ),
            ],
            1
          ),
        ])
      : _c(
          "div",
          [
            _vm.isRequestingItems
              ? _c(
                  "section",
                  [
                    _c("spinner-loader", {
                      attrs: { loading: _vm.isRequestingItems },
                    }),
                  ],
                  1
                )
              : _vm.items.length < 1
              ? _c(
                  "section",
                  { staticClass: "content-container" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticStyle: { "margin-top": "4px" },
                        on: {
                          click: function ($event) {
                            return _vm.$refs.itemModal.open()
                          },
                        },
                      },
                      [_vm._v("New Item")]
                    ),
                  ],
                  1
                )
              : _c(
                  "section",
                  { staticClass: "content-container" },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "b-row",
                          {
                            staticClass: "search-header",
                            attrs: { "align-h": "center" },
                          },
                          [
                            _c(
                              "b-col",
                              { staticClass: "my-1", attrs: { md: "6" } },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("b-form-input", {
                                      attrs: { placeholder: _vm.$t("search") },
                                      model: {
                                        value: _vm.filter,
                                        callback: function ($$v) {
                                          _vm.filter = $$v
                                        },
                                        expression: "filter",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { md: "2" } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticStyle: { "margin-top": "4px" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$refs.itemModal.open()
                                      },
                                    },
                                  },
                                  [_vm._v("New Item")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.isLoading
                      ? _c("b-table", {
                          staticClass: "inventory-table",
                          attrs: {
                            items: _vm.items,
                            fields: _vm.fields,
                            filter: _vm.filter,
                            hover: "",
                            striped: "",
                            fixed: "",
                          },
                          on: { "row-clicked": _vm.rowClicked },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(html)",
                                fn: function (data) {
                                  return _c("span", {
                                    domProps: { innerHTML: _vm._s(data.value) },
                                  })
                                },
                              },
                            ],
                            null,
                            false,
                            917124443
                          ),
                        })
                      : _c(
                          "div",
                          { staticClass: "fixed-center" },
                          [_c("spinner-loader")],
                          1
                        ),
                  ],
                  1
                ),
            _vm._v(" "),
            _c("item-modal", {
              ref: "itemModal",
              on: { submit: _vm.submitItem },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("\n        You don't have any items in your inventory yet. "),
      _c("br"),
      _vm._v('Create your\n        first one by clicking "New Item."\n      '),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }